import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import UndoIcon from '@mui/icons-material/Undo';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { undoLastAnnotationChange } from '../../actions/annotations';

type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = DispatchProps;

function UndoButton(props: Props) {
  return (
    <Tooltip disableInteractive disableFocusListener id="reset-page-tooltip" title="Undo">
      <div>
        <IconButton sx={{ borderRadius: 0, width: '100%' }} aria-label="Undo" onClick={props.undoLastAnnotationChange}>
          <UndoIcon />
        </IconButton>
      </div>
    </Tooltip>
  );
}

const actionCreators = {
  undoLastAnnotationChange,
};

export default connect(null, actionCreators)(UndoButton);
